import React, { useState, useEffect } from 'react';
import { Layout, Form, Input, Button, message, Divider } from 'antd';
import axios from 'axios';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from './config';
import { Preferences } from '@capacitor/preferences';
import '../styles/UserProfile.css'; // Assicurati di importare il CSS aggiuntivo

const { Content } = Layout;

const UserProfile = () => {
    const { user, setUser } = useUser();
    const [form] = Form.useForm();
    const [passwordForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [passwordLoading, setPasswordLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            form.setFieldsValue({
                nome: user.nome,
                cognome: user.cognome,
                email: user.email,
            });
        }
    }, [user, form]);

    const handleUpdateProfile = async (values) => {
        setLoading(true);
        const token = (await Preferences.get({ key: 'token' })).value;

        try {
            await axios.put(`${apiUrl}/api/auth/profile`, values, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            message.success('Profilo aggiornato con successo!');
            setUser((prevUser) => ({
                ...prevUser,
                ...values,
            }));
        } catch (error) {
            console.error("Errore durante l'aggiornamento del profilo:", error);
            message.error("Errore durante l'aggiornamento del profilo.");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdatePassword = async (values) => {
        setPasswordLoading(true);
        const token = (await Preferences.get({ key: 'token' })).value;

        if (values.newPassword !== values.confirmNewPassword) {
            message.error('Le nuove password non corrispondono');
            setPasswordLoading(false);
            return;
        }

        try {
            await axios.put(`${apiUrl}/api/auth/profile/password`, values, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            message.success('Password aggiornata con successo!');
            passwordForm.resetFields();
        } catch (error) {
            console.error("Errore durante l'aggiornamento della password:", error);
            message.error("Errore durante l'aggiornamento della password.");
        } finally {
            setPasswordLoading(false);
        }
    };

    const handleGoBack = () => {
        if (user && user.role === 'trainer') {
            navigate('/trainer-dashboard');
        } else {
            navigate('/cliente-dashboard');
        }
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ maxWidth: '100%', margin: '10px', paddingBottom: '70px' }}>
                <div className="edit-title">
                    MODIFICA PROFILO
                </div>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleUpdateProfile}
                    style={{ marginTop: '2rem' }}
                >
                    <Form.Item
                        label="Nome"
                        name="nome"
                        rules={[{ required: true, message: 'Inserisci il tuo nome' }]}
                        className="no-scroll-item"
                    >
                        <Input placeholder="Nome" />
                    </Form.Item>

                    <Form.Item
                        label="Cognome"
                        name="cognome"
                        rules={[{ required: true, message: 'Inserisci il tuo cognome' }]}
                        className="no-scroll-item"
                    >
                        <Input placeholder="Cognome" />
                    </Form.Item>

                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ required: true, type: 'email', message: 'Inserisci una email valida' }]}
                        className="no-scroll-item"
                    >
                        <Input placeholder="Email" disabled />
                    </Form.Item>

                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        loading={loading}
                        style={{ marginTop: '1rem' }}
                    >
                        Aggiorna Profilo
                    </Button>
                </Form>

                <Divider style={{ margin: '2rem 0' }} />

                <div className="edit-title">
                    MODIFICA PASSWORD
                </div>

                <Form
                    form={passwordForm}
                    layout="vertical"
                    onFinish={handleUpdatePassword}
                    style={{ marginTop: '1rem' }}
                >
                    <Form.Item
                        label="Password Attuale"
                        name="currentPassword"
                        rules={[{ required: true, message: 'Inserisci la password attuale' }]}
                        className="no-scroll-item"
                    >
                        <Input.Password placeholder="Password Attuale" />
                    </Form.Item>

                    <Form.Item
                        label="Nuova Password"
                        name="newPassword"
                        rules={[
                            { required: true, message: 'Inserisci la nuova password' },
                            {
                                pattern: /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/,
                                message: 'La password deve contenere almeno 8 caratteri e includere almeno un numero.',
                            },
                        ]}
                        className="no-scroll-item"
                    >
                        <Input.Password placeholder="Nuova Password" />
                    </Form.Item>

                    <Form.Item
                        label="Conferma Nuova Password"
                        name="confirmNewPassword"
                        dependencies={['newPassword']}
                        rules={[
                            { required: true, message: 'Conferma la nuova password' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Le nuove password non corrispondono'));
                                },
                            }),
                        ]}
                        className="no-scroll-item"
                    >
                        <Input.Password placeholder="Conferma Nuova Password" />
                    </Form.Item>

                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        loading={passwordLoading}
                        style={{ marginTop: '1rem' }}
                    >
                        Aggiorna Password
                    </Button>
                </Form>

                <Button
                    type="default"
                    onClick={handleGoBack}
                    block
                    className="custom-dashboard-button"
                    style={{ marginTop: '1rem' }}
                >
                    Torna alla Dashboard
                </Button>
            </Content>
        </Layout>
    );
};

export default UserProfile;
